import React from "react";
import { Img } from "../../design-system/Img";
import { deviceType } from "../../utils/types";

interface DeviceListItemProps {
  device: deviceType;
  handleApprove: (device: deviceType) => void;
}

const DeviceListItem: React.FC<DeviceListItemProps> = ({
  device,
  handleApprove,
}) => {
  const onDeviceClick = () => {
    handleApprove(device);
  };
  return (
    <div className="flex flex-col border rounded-md hover:cursor-pointer border-lightGray bg-blue_gray-50_03 h-[128px]  w-[398px]">
      <div
        className="flex flex-col p-4 gap-2 justify-between"
        onClick={onDeviceClick}
      >
        <div className="flex flex-row w-full justify-between border border-dashed border-x-0 border-t-0 pb-4 border-blue_gray-50_04">
          <p className="text-[14px] font-medium">Mobile</p>

          <Img
            src={"img_arrow_right.svg"}
            alt="Device"
            className="w-[20px] h-[20px] object-cover"
          />
        </div>

        <div className="flex flex-row justify-between">
          <div className="flex flex-col justify-between items-start gap-2">
            <p
              className="text-[12px] text-darkGray
            text-left
            font-medium"
            >
              Device Name
            </p>

            <p className="text-[12px] text-black-900 font-medium text-left">
              {device.deviceName}
            </p>
          </div>

          <div className="flex flex-col justify-between items-start">
            <p className="text-[12px] text-darkGray font-medium text-left">
              Type
            </p>

            <p className="text-[12px] text-black-900 font-medium text-left">
              {device.devicePlatform}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeviceListItem;
